import { Box, Button, Divider, Modal, Typography } from "@mui/material";

export const ModalV1 = ({
  open,
  handleClose,
  title,
  children,
  width = "500px",
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",

          background: "#fff",
          borderRadius: "8px",
          overflow: "hidden",
          width: width,
          maxWidth: "calc(100vw - 40px)",
          maxHeight: "calc(100dvh - 40px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            padding: "16px 20px 12px",
            gap: "8px",
          }}
        >
          <Typography fontSize={"20px"} lineHeight={"20px"} fontWeight={"600"}>
            {title}
          </Typography>

          <Button
            size="small"
            variant="outlined"
            color="error"
            sx={{
              ml: "auto",
              minWidth: "0",
              minHeight: "0",
              padding: "4px",
              width: "24px",
              height: "24px",
            }}
            onClick={handleClose}
          >
            <Typography>✖</Typography>
          </Button>
        </Box>
        <Divider />
        <Box
          sx={{
            padding: "12px 20px",
            maxHeight: "calc(100dvh - (40px + 100px))",
            overflow: "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </Modal>
  );
};
